import { Pipe, PipeTransform } from "@angular/core";
import { properCase } from "src/app/utils/text";

@Pipe({
  name: "propercase",
})
export class ProperCasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return null;
    }
    return properCase(value);
  }
}
